// App.js

import React from 'react';
import './i18n';
import AppV2 from './V2_App/App'; // Importa a versão 2 do App

const useVersion1 = false; // Define qual versão usar

function App() {
  return (
    <div className="App">
      {useVersion1 ? null : <AppV2 />}
    </div>
  );
}

export default App;
